import { useContext } from "react";

import { useTranslation } from "react-i18next";

import ControlsItemFrame from "components/Navbar/Controls/components/ControlsItemFrame";
import AuthContext from "context/auth/authContext";
import { useMediaQueries } from "shared/hooks/useMediaQueries";

import { CompanyFilterContentProps } from "../types";
import CompanySelector from "./CompanySelector";
import RootCompany from "./RootCompany";

const CompanyFilterContent = ({ close }: CompanyFilterContentProps) => {
    const { isSupportUser } = useContext(AuthContext);

    const { t } = useTranslation();
    const { toMd } = useMediaQueries();

    return (
        <div>
            <ControlsItemFrame
                close={close}
                boxPadding={
                    toMd ? "24px 16px 12px 16px" : "16px 16px 12px 16px"
                }
                itemName={t("Filter##company selector")}
            />

            {isSupportUser && <RootCompany />}

            <CompanySelector />
        </div>
    );
};

export default CompanyFilterContent;
